import { defineMessages } from "react-intl";

export const UNKNOWN_ERROR = "UNKNOWN_ERROR";

export const defaultMessages = defineMessages({
  [UNKNOWN_ERROR]: {
    defaultMessage: "Something went wrong",
  },
});
